import type { Utterance } from '../types';

export const updateUtterances = (prev: Utterance[], speaker: string, text: string, isPartial: boolean): Utterance[] => {
   const last = prev[prev.length - 1];
   if (last && last.speaker === speaker && last.isPartial) {
      const updated = [...prev];
      updated[updated.length - 1] = { speaker: speaker, text: text, isPartial: isPartial };
      return updated;
   }
   const clean = prev.filter((utterance) => !utterance.isPartial);
   clean.push({ speaker: speaker, text: text, isPartial: isPartial });
   return clean;
};

export const finalizeTrailingPartial = (utterances: Utterance[]): Utterance[] => {
   const last = utterances[utterances.length - 1];
   if (!last || !last.isPartial) {
      return utterances;
   }
   const updated = [...utterances];
   updated[updated.length - 1] = { ...last, isPartial: false };
   return updated;
};

export const buildSummaryUtterances = (utterances: Utterance[]): Array<{ speaker: string; text: string }> =>
   utterances
      .filter((utterance) => !utterance.isPartial)
      .map((utterance) => ({ speaker: utterance.speaker, text: utterance.text }));
